var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"login-name"},[_c(_setup.Input,{ref:"inputRef",attrs:{"state-key":_setup.usingStateKey}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }